import { rj } from 'react-rocketjump'
import magikApi from 'magik-api'
import { CSRF, SETTINGS } from '../../../django'
import rjList, {
  nextPreviousPaginationAdapter,
} from 'react-rocketjump/plugins/list'

// TODO: Unify API
const api = magikApi().trailingSlash(true).headers({
  'X-CSRFToken': CSRF,
})

export const LavorazioniState = rj()
  .plugins(
    rjList({
      pageSize: SETTINGS.PAGE_SIZE,
      pagination: nextPreviousPaginationAdapter,
    })
  )
  .computed({
    lavorazioni: 'getList',
  })
  .effect({
    name: 'LavorazioniState',
    effect: (params = {}) => api.get('/api/planner/lavorazioni', params),
  })
